import { CompetitionInfo } from './../../../../../data/mygolf.data';
import { GameRoundInfo } from './../../../../../data/game-round';
import { NavController, NavParams, ModalController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';

// import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-courses-modal',
  templateUrl: './courses-modal.page.html',
  styleUrls: ['./courses-modal.page.scss'],
})
export class CoursesModalPage implements OnInit {
  public competition: CompetitionInfo;
  public gameRound: Array<GameRoundInfo>;
  public headerName: string;

  constructor(
    public nav: NavController,
    private navParams: NavParams,
    private viewCtrl: ModalController
  ) {
    this.competition = this.navParams.get('competition');
    this.gameRound = this.navParams.get('gameRound');
    this.headerName = this.navParams.get('headerName');
  }

  close() {
    this.viewCtrl.dismiss();
  }

  ionViewDidLoad() {
 
  }

  getInnerHTML() {
    let description =
      "<p><span style='background-color:#00FFFF'>Tournaments, electronic scorecards, analysis and more&hellip; Look no further! myGolf2u is a single place where you can find and register for any </span>competitions in your region, your favourite clubs or in the entire country on your phone or in this site.</p>";
    return description;
  }

  ngOnInit() {}
}
